// 网格卡片淡入过渡钩子（Product / Funding / Channel 三 grid 完全一致）
// 作为 mixin 接入，避免每处重复定义 beforeEnter/enter/leave。
export default {
  methods: {
    // 动画进入前的准备，设置透明度为 0
    beforeEnter(el) {
      el.style.opacity = 0;
    },

    // 动画进入时的过渡效果
    enter(el, done) {
      setTimeout(() => {
        el.style.transition = 'opacity 2.5s ease';
        el.style.opacity = 1;
        done();
      });
    },

    // 动画离开时的过渡效果
    leave(el, done) {
      el.style.transition = 'opacity 0.3s ease';
      el.style.opacity = 0;
      setTimeout(() => {
        done();
      }, 300);
    },
  },
};
